import React from "react";
import { DowntimeNoteLoaderTemplate } from "../../../../themes/default/application/device-settings/components/content-loader";

function DowntimeNoteLoader(props) {
    return <DowntimeNoteLoaderTemplate {...props} />;
}

export default DowntimeNoteLoader;
